import { useEffect } from "react";
import { Chips } from "gf-ui-components-mui-lib";
import FilterKeywordClose from "../../../assets/svg/filter-keyword-close.svg";
import styled from "@emotion/styled";
import { useTableContext } from "../../../context/tableContext";
import { filters } from "../../organisms/filterWindow/renderFilters";

const ChipSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const FilterKeywords = () => {
  const {
    checked,
    setChecked,
    connectors,
    handleConnectors,
    handleConnectorType,
    connectorType,
    setApplyFilter,
    renderRecords,
    qrFlag,
    handleQrFlag,
    filterStatus,
    handleFilterStatus,
    filterModel,
    handleModel,
    filterOcpp,
    handleOcpp,
    filterTenant,
    handleTenant,
  } = useTableContext();

  useEffect(() => {
    if (
      checked?.length === 0 &&
      connectors?.length === 0 &&
      connectorType?.length === 0 &&
      filterStatus?.length === 0 &&
      filterModel === "" &&
      filterTenant === "" &&
      filterOcpp === ""
    ) {
      setApplyFilter(false);
      renderRecords();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    checked,
    connectors,
    connectorType,
    filterStatus,
    filterModel,
    filterTenant,
    filterOcpp,
  ]);

  const renderLists = (arr: any, filterEnum: any) => {
    return arr?.map((item: any, index: number) => (
      <KeywordsContainer
        key={index}
        label={item}
        deleteKeyword={() => deleteKeyword(arr, filterEnum, index)}
      />
    ));
  };

  const deleteKeyword = (arr: any, filterEnum: any, key: number) => {
    if (filterEnum === filters.vendor) {
      arr?.splice(key, 1);
      setChecked([...arr]);
    } else if (filterEnum === filters.connectorType) {
      let tempArr = arr;
      tempArr.splice(key, 1);
      handleConnectorType([...tempArr]);
    } else if (filterEnum === filters.status) {
      arr?.splice(key, 1);
      handleFilterStatus([...arr]);
    }
  };

  const renderText = (value: string, filterEnum: any) => {
    return (
      <KeywordsContainer
        label={value}
        deleteKeyword={() => deleteText(value, filterEnum)}
      />
    );
  };

  const deleteText = (value: string, filterEnum: any) => {
    if (filterEnum === filters.model) {
      handleModel("");
    } else if (filterEnum === filters.ocppVersion) {
      handleOcpp("");
    } else if (filterEnum === filters.qrCode) {
      handleQrFlag("");
    } else if (filterEnum === filters.tenant) {
      handleTenant("");
    } else if (filterEnum === filters.noConnectors) {
      handleConnectors("");
    }
  };

  return (
    <ChipSectionWrapper>
      {checked?.length > 0 && renderLists(checked, filters.vendor)}
      {connectors && renderText(connectors, filters.noConnectors)}
      {connectorType?.length > 0 &&
        renderLists(connectorType, filters.connectorType)}
      {filterStatus?.length > 0 && renderLists(filterStatus, filters.status)}
      {filterModel && renderText(filterModel, filters.model)}
      {filterOcpp && renderText(filterOcpp, filters.ocppVersion)}
      {qrFlag && renderText(qrFlag, filters.qrCode)}
      {filterTenant && renderText(filterTenant, filters.tenant)}
    </ChipSectionWrapper>
  );
};

const KeywordsContainer = ({
  key,
  label,
  deleteKeyword,
}: {
  key?: number;
  label: string;
  deleteKeyword: any;
}) => {
  return (
    <Chips
      label={label}
      deleteIcon={<img src={FilterKeywordClose} alt="" />}
      onDelete={deleteKeyword}
      sx={{
        borderRadius: "1000px",
        background: "#F5ECFF",
        padding: "6px 12px",
        gap: "8px",
        color: "var(--secondary-500, #7326BF)",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "16px",
        marginRight: "8px",
      }}
    />
  );
};
